import React from 'react';
import { Typography, useTheme } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { Feature } from '../../../types/api-definitions';
import Tag from '../Tag';
import {
  StyledContainer,
  StyledImageContainer,
  StyledImage,
  StyledPlaceholder,
  StyledContentContainer,
  StyledTagsContainer,
  StyledDescription,
} from './FeatureDisplay.styles';

interface FeatureDisplayProps {
  feature: Feature;
  description: string;
}

const FeatureDisplay: React.FC<FeatureDisplayProps> = ({ feature, description }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { slug } = useParams<{ slug: string }>();

  const isCursorPointer = Boolean(feature.demoContent || !slug);

  const handleFeatureClick = () => {
    const canNavigate = feature.demoContent && slug;
    if (canNavigate) {
      navigate(`/api-definitions/${slug}/feature/${feature.slug}`);
    }
  };

  return (
    <StyledContainer onClick={handleFeatureClick} isCursorPointer={isCursorPointer}>
      <StyledImageContainer>
        {feature.imagePath ? (
          <StyledImage src={feature.imagePath} alt={feature.name} />
        ) : (
          <StyledPlaceholder>
            <Typography variant='body1'>{feature.name}</Typography>
          </StyledPlaceholder>
        )}
      </StyledImageContainer>
      <StyledContentContainer>
        <Typography variant='body1' sx={{ fontWeight: 600 }}>
          {feature.name}
        </Typography>
        <StyledTagsContainer>
          {feature.tags.map((tag) => (
            <Tag
              key={tag.slug}
              text={tag.name}
              backgroundColor={theme.palette.tags.darkTagBackground}
              color={theme.palette.tags.darkTagText}
            />
          ))}
        </StyledTagsContainer>
        <StyledDescription variant='body2'>{description}</StyledDescription>
      </StyledContentContainer>
    </StyledContainer>
  );
};

export default FeatureDisplay;
